import * as React from "react";
export const FolderActionContext = React.createContext(undefined);
export const useFolderActionContext = () => {
    const context = React.useContext(FolderActionContext);
    if (typeof context === "undefined") {
        throw new Error("useFolderActionContext must be used within a FolderActionContextProvider");
    }
    return context;
};
